import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom';
import App from './App';
import { injectInterceptorShim } from './custom/components/componentInterceptor';

injectInterceptorShim();
ReactDOM.render(<App />, document.getElementById('root'));
